<template>
  <v-container fluid class="pa-2">
    <v-row>
      <v-col v-if="impersonationAlert" class="py-3">
        <v-alert
          type="warning"
          v-model="impersonationAlert"
          closable
          class="banner-close-icon"
          density="compact"
          variant="outlined"
        >
          You're currently impersonating: {{ impersonatedAgent }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <router-view name="default" lazy></router-view>
        <router-view name="view" lazy></router-view>
      </v-col>
    </v-row>
    <div v-if="impersonationDialog">
      <impersonation-dialog
        :dialog.sync="impersonationDialog"
        :dialogType="impersonateDialogType"
        :brokerageName.sync="impersonatedAgent"
        @cancel="impersonateCancel"
        @disable="disableImpersonation"
      />
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { defineAsyncComponent } from "vue";

export default {
  props: {},
  components: {
    ImpersonationDialog: defineAsyncComponent(
      () => import("@/components/console/dialog/ImpersonationDialog.vue"),
    ),
  },
  data() {
    return {
      impersonationAlert: false,
      impersonationDialog: false,
      impersonateDialogType: "disableImpersonate",
    };
  },
  methods: {
    impersonateCancel() {
      this.impersonationAlert = true;
      this.impersonationDialog = false;
    },
    disableImpersonation() {
      this.$store.dispatch("auth/clearImpersonate").then(() => {
        this.impersonationDialog = false;
        this.$router.push("/console/brokerages");
      });
    },
  },
  computed: {
    ...mapGetters("auth", ["impBrokerage", "impUser"]),
    impersonatedAgent() {
      if (this.impBrokerage === null) {
        return "";
      }

      return this.impBrokerage.name;
    },
  },
  watch: {
    impersonationAlert(n) {
      if (n === false) {
        this.impersonationDialog = true;
      }
    },
  },
  mounted() {
    this.impersonationAlert = false;
    if (this.impBrokerage) {
      this.impersonationAlert = true;
    }
  },
};
</script>

<style scoped>
.banner-close-icon :deep(.v-btn .v-icon) {
  font-size: 20px !important;
}
.v-alert :deep(.v-icon) {
  font-size: 22px !important;
  margin-top: 6px;
}
</style>
